/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ISzfCarouselContainerViewProps } from './szf-carousel-container';
import Slider from 'react-slick';
import get from 'lodash/get';
export default (props: ISzfCarouselContainerViewProps) => {
    const carouselcontentCount: number = props.config?.carouselcontentCount || 4;
    const { config: { autoPlay, autoplaySpeed, pauseOnMouseHover }, context: { request: { textDirection } } } = props;
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: carouselcontentCount,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow:carouselcontentCount <= 3 ? carouselcontentCount : 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: carouselcontentCount <= 2 ? carouselcontentCount : 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        autoplay: autoPlay,
        autoplaySpeed: autoplaySpeed ? autoplaySpeed : 0,
        pauseOnHover: pauseOnMouseHover, 
        [textDirection]: true
    };
    return (
        <React.Fragment>
            <Slider {...settings}>
                {props.slots.content.map((contentBlock, i) => {
                    const links = get(contentBlock, 'props.config.links');
                    return (
                        links && links.length > 0 ? (
                            <a onClick={() => { window.open(links[0].linkUrl.destinationUrl, `${links[0].openInNewTab ? '_blank' : '_self'}`); }} className='single-carousel-slot' key={`szf-carousel-container-${i}`}>
                                {contentBlock}
                            </a>
                        ) : (
                                <div className='single-carousel-slot' key={`szf-carousel-container-${i}`}>
                                    {contentBlock}
                                </div>
                            )
                    );
                })}
            </Slider>
        </React.Fragment>
    );
};
